import React, { useEffect, useState } from "react";
import { ReactComponent as RightArrow } from "assets/img/icons/rightArrow.svg";
import { ReactComponent as LeftArrow } from "assets/img/icons/leftArrow.svg";
import Button from "components/CustomButton";
import TimelineService from "services/TimelineService";
import { Rating } from "react-simple-star-rating";
import { useTimelineContext } from "store/contexts/timelineContext";
import { useToasts } from "react-toast-notifications";
import { useLocation } from "react-router-dom";

function PostRate({ post }) {
  const { search } = useLocation();
  const user_rating = new URLSearchParams(search)?.get("user_rating");
  const [showRate, setShowRate] = useState(false);
  const [isRated, setIsRated] = useState(post?.ratings?.is_user_rated);
  const [rating, setRating] = useState(post?.ratings?.user_rating ?? 0);
  const { company_id, updatePost } = useTimelineContext();
  const { addToast } = useToasts();
  const companyId = company_id;
  const formattedRating = (rating) => parseFloat(rating).toFixed(1);
  const [disableRating, setDRating] = useState(false);
  const [totalRatings, setTotalRatings] = useState(post?.ratings?.total_rating);
  const [avgRating, setAvgRating] = useState(
    formattedRating(post?.ratings?.avg_rating)
  );

  useEffect(() => {
    if (!user_rating) return;

    console.log(user_rating);
    setAvgRating(formattedRating(user_rating));
    setTotalRatings(1);
    setDRating(true);

  }, [user_rating])

  const handleRating = async (rate) => {
    setRating(rate);
  };

  const submitRating = async () => {
    try {
      const resp = await TimelineService.createRating(
        post?.id,
        companyId,
        rating
      );
      // update user count
      setTotalRatings(totalRatings + 1);
      // update the latest updated average rating
      const newPost = {
        ...post,
        ratings: {
          is_user_rated: true,
          avg_rating: resp.data.data.avg_rating,
          user_rating: resp.data.data.rating,
          total_rating: post.ratings.total_rating + 1
        }
      }


      updatePost(newPost);
      setAvgRating(formattedRating(resp.data.data.avg_rating));
      setIsRated(true);
      setShowRate(false);
    } catch (e) {
      console.log(e);
      addToast(e?.response?.data?.message ?? "Some error occurred.", {
        appearance: "error",
      });
    }
  };

  return (
    <>
      {showRate && (
        <div className="rate-modal">
          <div className="rate-back">
            <LeftArrow
              className="rate-idea-svg"
              onClick={() => setShowRate(false)}
            />
          </div>
          <div className="rate-modal-content">
            <Rating onClick={handleRating} allowFraction />
            <div>
              <Button
                onClick={submitRating}
                buttonClass="grad_btn summary-button"
              >
                Rate Now
              </Button>
            </div>
          </div>
        </div>
      )}
      {!showRate && (
        <div className="d-flex justify-content-between align-items-center">
          <div className="initial-avg-rating">
            <div>{avgRating}</div>
            <Rating initialValue={avgRating} readonly allowFraction />
            <div>({totalRatings})</div>
          </div>
          <div className="rate-idea">
            {isRated && !disableRating && (
              <div className="rate-idea-text">You rated: {rating}</div>
            )}
            {!isRated && !disableRating && (
              <div
                className="rate-idea-cursor"
                onClick={() => setShowRate(true)}
              >
                <div className="rate-idea-text">Rate this Idea</div>
                <div>
                  <RightArrow className="rate-idea-svg" />
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default PostRate;
